import Http from '@/api/http.js'

export default {
  indexPeriodicConsolidation(params){
    // console.log({params});
    return Http.get(`/periodic_consolidations`, {params: {...params}});
  },
  showPeriodicConsolidation(id){
    return Http.get(`/periodic_consolidations/${id}`);
  },
  updatePeriodicConsolidation(consolidation){
    return Http.put(`/periodic_consolidations/${consolidation.id}`, {consolidation: {...consolidation}})
  },

  indexConsolidation(){
    return Http.get(`clients/consolidations`);
  },

  showConsolidation(client_id){
    return Http.get(`clients/${client_id}/consolidations`);
  },

  indexPaymentsResume(client_id){
    return Http.get(`clients/${client_id}/payment_resume`);
  },

}